export const quote_budget_locale = {
  RESULT: "Result",
  RESULT_HINT: "All revenue totals (excl. VAT) - all cost totals (excl. VAT)",
  NO_EXCHANGE_RATE_CONFIGURED: "No exchangeRate found (exchange rate will be configured on save)",
};
